import React from 'react'

import logoAuteco from './../../UI/logos/logo-auteco.svg'

interface Props{
    handleHideInfoScreen: any
    rotationChanged: boolean
    isLoading: boolean
}

interface State{
    isInformation: boolean
}

class WelcomeMobile extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            isInformation: false
        }
    }

    componentDidMount(){
        this.setState({
            isInformation: true
        })
    }

    handleChangeInformationState = () => {
        this.setState({
            isInformation: false
        })
        this.props.handleHideInfoScreen()
    }

    render(){
        return(
            <div className={this.state.isInformation || (this.props.rotationChanged && !this.props.isLoading) ? "welcome-screen-mobile fade-in":"welcome-screen-mobile fade-out"}>
                <div className='welcome-logo-container-mobile'>
                    <img src={logoAuteco} alt=""/>
                </div>
                <div className='welcome-text-container-mobile'>
                    <div className='title-text-mobile'>BIENVENIDO</div>
                    <div className='secondary-text-mobile'>Al showroom virtual de Auteco</div>
                </div>
                <div className='welcome-btn-container-mobile' onClick={() => {this.handleChangeInformationState()}}>
                    Entrar
                </div>
            </div>
        )
    }
}

export default WelcomeMobile